import React, { useState, useEffect } from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Input,
  HStack,
  Select,
  Button,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { FaCalendarAlt } from 'react-icons/fa';

// Helper: สร้างรายการปี พ.ศ. ย้อนหลัง 10 ปี และล่วงหน้า 10 ปี
const currentBuddhistYear = new Date().getFullYear() + 543;
const years = Array.from({ length: 21 }, (_, i) => currentBuddhistYear - 10 + i);

// Helper: สร้างรายการวัน
const days = Array.from({ length: 31 }, (_, i) => i + 1);

// Helper: สร้างรายการเดือน
const months = [
  { value: 1, name: 'มกราคม' }, { value: 2, name: 'กุมภาพันธ์' },
  { value: 3, name: 'มีนาคม' }, { value: 4, name: 'เมษายน' },
  { value: 5, name: 'พฤษภาคม' }, { value: 6, name: 'มิถุนายน' },
  { value: 7, name: 'กรกฎาคม' }, { value: 8, name: 'สิงหาคม' },
  { value: 9, name: 'กันยายน' }, { value: 10, name: 'ตุลาคม' },
  { value: 11, name: 'พฤศจิกายน' }, { value: 12, name: 'ธันวาคม' },
];

const ManualThaiDatePicker = ({ value, onChange, name, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  // State ภายในสำหรับจัดการ วัน/เดือน/ปี ที่เลือกใน dropdown
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  
  // State สำหรับแสดงผลใน Input
  const [displayValue, setDisplayValue] = useState('');

  // เมื่อค่า value จากข้างนอกเปลี่ยน ให้มาตั้งค่าภายใน
  useEffect(() => {
    if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split('-').map(Number);
      const beYear = year + 543;
      setSelectedDay(day);
      setSelectedMonth(month);
      setSelectedYear(beYear);
      setDisplayValue(`${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${beYear}`);
    } else {
      // ถ้าค่า value ไม่มีหรือ format ไม่ถูก ก็ล้างค่าทั้งหมด
      setDisplayValue('');
      setSelectedDay('');
      setSelectedMonth('');
      setSelectedYear('');
    }
  }, [value]);

  const handleSelect = () => {
    if (selectedDay && selectedMonth && selectedYear) {
      const adYear = selectedYear - 543;
      const dayStr = String(selectedDay).padStart(2, '0');
      const monthStr = String(selectedMonth).padStart(2, '0');

      // ส่งค่ากลับไปหาฟอร์มหลักในรูปแบบ ค.ศ. (YYYY-MM-DD)
      onChange({
        target: {
          name: name,
          value: `${adYear}-${monthStr}-${dayStr}`,
        },
      });
      setIsOpen(false); // ปิด Popover
    }
  };

  return (
    <Popover isOpen={isOpen} onOpen={() => setIsOpen(true)} onClose={() => setIsOpen(false)} placement="bottom-start">
      <PopoverTrigger>
        <InputGroup>
          <Input
            value={displayValue}
            readOnly
            placeholder="วว/ดด/ปปปป"
            cursor="pointer"
            {...rest}
          />
          <InputRightElement cursor="pointer">
            <FaCalendarAlt color="gray.300" />
          </InputRightElement>
        </InputGroup>
      </PopoverTrigger>
      <PopoverContent p={2} w="auto">
        <PopoverBody>
          <HStack spacing={2}>
            <Select placeholder="วัน" value={selectedDay} onChange={(e) => setSelectedDay(Number(e.target.value))}>
              {days.map(d => <option key={d} value={d}>{d}</option>)}
            </Select>
            <Select placeholder="เดือน" value={selectedMonth} onChange={(e) => setSelectedMonth(Number(e.target.value))}>
              {months.map(m => <option key={m.value} value={m.value}>{m.name}</option>)}
            </Select>
            <Select placeholder="ปี (พ.ศ.)" value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
              {years.map(y => <option key={y} value={y}>{y}</option>)}
            </Select>
          </HStack>
          <Button colorScheme="blue" size="sm" w="100%" mt={3} onClick={handleSelect}>
            ตกลง
          </Button>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ManualThaiDatePicker;